<template>
	<div>
		<div class="border-bottom pb-3 mb-6">
            <div class="display-3 kp-title">Object ID</div>
        </div>
        <div class="border-bottom pb-3 mb-7">
            <div class="d-flex align-items-center mb-5">
                <h3 class="card-title mb-0 text-muted">Object Information</h3>                            
            </div>
            <div>
                <div class="row mb-2">
                    <label class="col-sm-3">ID</label>
                    <div class="col-sm-6">
                        <span>{{item.id}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Object ID</label>
                    <div class="col-sm-6">
                        <span>{{item.object_id}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Created</label>
                    <div class="col-sm-6">
                        <span>{{item.createdAt | df}}</span>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Track</label>
                    <div class="col-sm-6">
                        <router-link :to="{name: 'track-details', params: {id: item.track.id}}">{{item.track.name}}</router-link>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Observer</label>
                    <div class="col-sm-6">
                        <router-link v-if="item.track_observer" :to="{name: 'observer-details', params: {id: item.track_observer.id}}">{{item.track_observer.id}}</router-link>
                    </div>
                </div>
                <div class="row mb-2">
                    <label class="col-sm-3">Bucket</label>
                    <div class="col-sm-6">
                        <router-link v-if="item.track_bucket" :to="{name: 'bucket-details', params: {id: item.track_bucket.id}}">{{item.track_bucket.name}}</router-link>
                    </div>
                </div>
            </div>
        </div>        	
	</div>
</template>

<script type="text/javascript">
    import {HTTP} from '@/components/HTTP.js'
    import DateFormat from '@/components/DateFilter.js'

    export default {
        created: function(){
            this.id = this.$route.params.id;
            this.fetch()
        },
        filters: {
            df: DateFormat
        },
        data: function(){
            return {
                id: "",
                item: {
                    track: {},
                    track_bucket: {},
                    track_observer: {
                        observer: {}
                    }
                }
            }
        },
        methods: {
            fetch: function(){
                HTTP.get('/e/rail/' + this.id)
                .then((res) => {
                    if (res.data.status) {
                        this.item = res.data.data.rail;
                    }                   
                })
                .catch((e) => {
                    console.log("Error response", e);
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/objects/ObjectDetails.vue